var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-icon',{staticClass:"action-save-icon"},[_vm._t("default",[_vm._v("mdi-content-save")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }